import type { Virtualizer } from "@tanstack/react-virtual";

import type { TabbedDropdownItemType } from "app/pages/sales-intelligence/types/types";

import DropdownWithTabsHighlightedItem from "../DropdownWithTabsHighlightedItem/DropdownWithTabsHighlightedItem";

export type DropdownVirtualListProps = {
    virtualizer: Virtualizer<Element, Element>;
    items: readonly TabbedDropdownItemType[];
    itemHeight: number;
    onItemClick: (item: TabbedDropdownItemType) => void;
    isSingleSelect?: boolean;
    tooltipForDisabledItem?: string;
};

const DropdownVirtualList = (props: DropdownVirtualListProps) => {
    const { virtualizer, items, itemHeight, onItemClick, isSingleSelect, tooltipForDisabledItem } = props;

    return (
        <div
            style={{
                height: `${virtualizer.getTotalSize()}px`,
                paddingTop: `${virtualizer.getVirtualItems()[0]?.start ?? 0}px`,
                boxSizing: "border-box",
            }}
        >
            {virtualizer.getVirtualItems().map((virtualItem) => {
                const item = items[virtualItem.index];

                return (
                    <DropdownWithTabsHighlightedItem
                        item={item}
                        itemHeight={itemHeight}
                        onClick={() => onItemClick(item)}
                        key={`item-${item.name}-${item.type}`}
                        isSingleSelect={isSingleSelect}
                        tooltipForDisabledItem={tooltipForDisabledItem}
                    />
                );
            })}
        </div>
    );
};

export default DropdownVirtualList;
